import React from 'react';
import { ReturnPolicy } from '../../../generated/types/globalTypes';
import { ReturnPolicyHyperlink } from '../../ReturnPolicyInformation';
import { ProductDetailsShippingAndReturnsCopy } from './ProductShippingAndReturnsCopy';

interface Props {
  shippingRestrictions: string;
  returnPolicy: ReturnPolicy | null;
}

export const ProductDetailsShippingAndReturns: React.FC<Props> = ({
  shippingRestrictions,
  returnPolicy
}) => (
  <ul className="ProductDetailsShippingAndReturns">
    {shippingRestrictions && <li>{shippingRestrictions}</li>}

    <li>
      <ProductDetailsShippingAndReturnsCopy returnPolicy={returnPolicy} />{' '}
      <ReturnPolicyHyperlink>Learn more.</ReturnPolicyHyperlink>
    </li>
  </ul>
);
